"use strict";

module.exports = {
  'name': 'setSize',
  'category': 'Set',
  'syntax': ['setSize(set)', 'setSize(set, unique)'],
  'description': 'Count the number of elements of a (multi)set. When the second parameter "unique" is true, count only the unique values. A multi-dimension array will be converted to a single-dimension array before the operation.',
  'examples': ['setSize([1, 2, 2, 4])', 'setSize([1, 2, 2, 4], true)'],
  'seealso': ['setUnion', 'setIntersect', 'setDifference']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/set/setSize.js
// module id = 938
// module chunks = 0